import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import { CursorArrowRaysIcon, EnvelopeOpenIcon, UsersIcon } from '@heroicons/react/24/outline'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

const stats = [
  {
    id: 1,
    name: 'Products in store',
    action: () => toast.error('Function is not avaiable right now.'),
    path: '',
    stat: '71,897',
    icon: UsersIcon,
    change: '122',
    changeType: 'increase'
  },
  {
    id: 2,
    name: 'Products incomming',
    action: () => toast.error('Function is not avaiable right now.'),
    path: '',
    stat: '58.16%',
    icon: EnvelopeOpenIcon,
    change: '5.4%',
    changeType: 'increase'
  },
  {
    id: 3,
    name: 'Products sold',
    action: () => toast.error('Function is not avaiable right now.'),
    path: '',
    stat: '24.57%',
    icon: CursorArrowRaysIcon,
    change: '3.2%',
    changeType: 'decrease'
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const InventoryStats = () => {
  const navigate = useNavigate()

  const handleAction = (action) => {
    if (action.action) action.action()
    else if (action.path) navigate(action.path)
  }

  return (
    <div className="mt-5">
      <dl className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((item) => (
          <div
            key={item.id}
            className="relative overflow-hidden rounded-lg bg-white px-6 pt-6 pb-8 shadow-sm ring-1 ring-inset ring-gray-200 transition-all duration-200 hover:shadow-md hover:ring-gray-300"
          >
            <dt className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-blue-500 shadow-sm ring-1 ring-inset ring-blue-600/10">
                  <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">{item.name}</p>
                  <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900">{item.stat}</p>
                </div>
              </div>
            </dt>
            <dd className="mt-6 flex items-baseline justify-between">
              <div className="flex items-baseline space-x-2">
                {item.changeType === 'increase' ? (
                  <ArrowUpIcon className="h-5 w-5 flex-shrink-0 text-green-500" aria-hidden="true" />
                ) : (
                  <ArrowDownIcon className="h-5 w-5 flex-shrink-0 text-red-500" aria-hidden="true" />
                )}
                <p
                  className={classNames(
                    item.changeType === 'increase' ? 'text-green-600' : 'text-red-600',
                    'text-sm font-semibold'
                  )}
                >
                  <span className="sr-only">
                    {item.changeType === 'increase' ? 'Increased' : 'Decreased'} by{' '}
                  </span>
                  {item.change}
                </p>
              </div>
              <button
                type="button"
                onClick={() => handleAction(item)}
                className="inline-flex items-center rounded-md bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-colors hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                View all
                <span className="sr-only"> {item.name} stats</span>
              </button>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
